import React from 'react';

/** Lazy ClientComputedLeaderboard (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedLeaderboard = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-learning-leaderboard' */
            './ClientComputedLeaderboard'
        ),
);
